import styled from "styled-components";

export const Message = styled.div`
    border-radius: 16px;
    padding: 24px;
    width: 100%;
    background: var(--light-text);
    box-shadow: var(--shadow);
`;